import dailyConfig from '@com/core/noon/dailyConfig';
import { TAppConfig } from '@com/core/common/types/config';

// const IMG_BASE = `${process.env.CDN}/s/app/com/noon/`;

// type TBigalogConfig = TAppConfig && {};

const appConfig: TAppConfig = {
    ...dailyConfig,
    port: 3003,
    gtm: {
        ...dailyConfig.gtm,
        PLATFORM_TYPE: 'desktop',
    },
    commonHeaders: {
        ...dailyConfig.commonHeaders,
        'x-content': 'desktop',
        'x-experience': 'daily',
    },
    logging: {
        sentryDSN: 'https://45342790f8a84d22aa38a0410620bf9f@sentry.noon.team/121',
        sentryEnabled: false,
    },
    assets: {
        ...dailyConfig.assets,
        // images: {
        //     ...dailyConfig.assets.images,
        // },
        // Add more here, but also update the type L#6
    },
    /**
     * IMPORTANT
     * ---------
     * 1. ALWAYS make sure that the page names are same as the file names in the pages folder.
     * 2. The [...catalog] route should always be at the end of the routes array. Or else everything will be routed to catalog.
     * 3. Page name should ALWAYS start with a '/'.
     */
    routes: [
        {
            page: '/account/auto-deliveries',
            pathMatch: /^\/account\/auto-deliveries([/#?](.+)?)?$/,
        },
        {
            page: '/account/subscriptions',
            pathMatch: /^\/account\/subscriptions([/#?](.+)?)?$/,
        },
        {
            page: '/account/credits',
            pathMatch: /^\/account\/credits([/#?](.+)?)?$/,
        },
        {
            page: '/account/addresses',
            pathMatch: /^\/account\/addresses([/#?](.+)?)?$/,
        },
        {
            page: '/account/payments',
            pathMatch: /^\/account\/payments([/#?](.+)?)?$/,
        },
        {
            page: '/account/profile',
            pathMatch: /^\/account\/profile([/#?](.+)?)?$/,
        },
        {
            page: '/account/orders/:order/help',
            pathMatch: /^\/account\/orders\/[A-Za-z0-9].+?\/help([/#?](.+)?)?$/,
        },
        {
            page: '/account/orders/[order]',
            pathMatch: /^\/account\/orders\/[A-Za-z0-9].+?([/#?](.+)?)?$/,
        },
        {
            page: '/account/orders',
            pathMatch: /^\/account\/orders([/#?](.+)?)?$/,
        },
        {
            page: '/account/complain-return',
            pathMatch: /^\/account\/complain-return([/#?](.+)?)?$/,
        },
        {
            page: '/account',
            pathMatch: /^\/account([/#?](.+)?)?$/,
        },
        {
            page: '/cart',
            pathMatch: /^\/cart([/#?](.+)?)?$/,
        },
        {
            page: '/payment',
            pathMatch: /^\/payment([/#?](.+)?)?$/,
        },
        {
            page: '/account/monthly-spendings',
            pathMatch: /^\/account\/monthly-spendings([/#?](.+)?)?$/,
        },
        {
            page: '/[...catalog]',
            pathMatch: /^\/.+/,
        },
    ],
};

export default appConfig;
